import React, {useState, useEffect, useLayoutEffect, useRef} from 'react'
import {Stack, HStack, Box, Flex, Checkbox, Heading, Text,} from '@chakra-ui/react'
import {ChakraSelectLabel, InputLabel} from '../../../../components/Theme'
import NavigateModal from './NavigateModal'
import Loading from "../../../Loading";
import {useGetCustomBids, useGetRecommended} from "../../../../core/hooks";
import {CONTROL_FILTER, PRODUCT_TYPES} from "../../../../constants/types";
import {SU} from "../../../../constants/user/userEnum";
import {ReactComponent as DollarIcon} from "../../../../assets/Icons/dollarIcon.svg";
import {ReactComponent as PendingIcon} from "../../../../assets/Icons/pendingIcon.svg";
import {ReactComponent as ArrowDownIcon} from "../../../../assets/downArrow.svg";
import styles from "../styles";
import {CONTROL_TYPE, setLedsForAll, updateProductType} from "../../../../constants/utils";
import CustomSelectMultiple from "../../Parts/CustomSelectMultiple";
import {expandedSearchStyles} from "../../../../constants/expandedSearch";

const {colors: expandedSearchColors, textColors: expandedSearchTextColors} = expandedSearchStyles.control;

const Control = ({
                     onClose,
                     project,
                     luminaireId,
                     createKey,
                     setCreateKey,
                     fromAll,
                     reportId,
                     area,
                     luminaire,
                     control,
                     setControl,
                     setArea,
                     setRecent,
                     setType,
                     description,
                     customPricing,
                     type,
                     setCustomPricing,
                 }) => {
    const [fetchedDataControl, setFetchedDataControl] = useState([])
    const [expandedSearch, setExpandedSearch] = useState([])
    const [isOpen, setIsOpen] = useState(false);
    const resultsListRef = useRef(null)
    const [selectAll, setSelectAll] = useState(false);
    const [controlAirtable, setControlAirtable] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [filters, setFilters] = useState({
        type: '',
        manufacturer: '',
        model: '',
        productCode: '',
        depth: '',
        length: '',
        width: '',
        diameter: ''
    })
    const [buyAmerican, setBuyAmerican] = useState(false);
    const [customBids, setCustomBids] = useState([]);
    const {data, isLoading,isFetching, refetch} = useGetRecommended(
        {
            condition: {
                table: PRODUCT_TYPES["4"],
                filter: CONTROL_FILTER(luminaire),
                projectId: project?.id,
            }
        },
        expandedSearch.length > 0 ? CONTROL_FILTER(luminaire, expandedSearch) : undefined
    )
    const {data: dataCustomBids, isLoading: isLoadingBids,isFetching:isFetchingBids, refetch: refetchBids} = useGetCustomBids(
        {
            condition: {
                type: 'report',
                projectId: project?.id,
                productType: 'control',
                reportId: reportId,
                userType: SU,
            }
        }
    )
    console.log(customPricing.control)
    const validate = ({fields}) => {
        if (expandedSearch.includes(fields['Type'])) {
            return true
        }

        let bool = true
        if (buyAmerican && bool){
            !!fields['Buy America'] ? bool = fields['Buy America'] === 'Yes' : bool = false
        }
        if (!customPricing.control && bool){
            (!fields.hasOwnProperty('Price Per Unit ($)') || !fields['Price Per Unit ($)'] || Number(fields['Price Per Unit ($)']) == 0) ? bool = false : bool = true
        }
        if (customPricing.control && bool) {
            (!fields.hasOwnProperty('Price Per Unit ($)') || !fields['Price Per Unit ($)'] || Number(fields['Price Per Unit ($)']) == 0) ? bool = true : bool = false
        }
        if (!!filters?.manufacturer && bool) {
            !!fields['Manufacturer'] ? bool = fields['Manufacturer'].toLowerCase().includes(filters.manufacturer.toLowerCase()) : bool = false
        }
        if (!!filters?.model && bool) {
            !!fields['Variable 3'] ? bool = fields['Variable 3'].toLowerCase().includes(filters.model.toLowerCase()) : bool = false
        }
        if (!!filters?.productCode && bool) {
            !!fields['Product Code'] ? bool = fields['Product Code'].toLowerCase().includes(filters.productCode.toLowerCase()) : bool = false
        }
        if (!!filters?.depth && bool) {
            !!fields['Depth (inches)'] ? bool = fields['Depth (inches)'] == filters.depth : bool = false
        }
        if (!!filters?.width && bool) {
            !!fields['Width (inches)'] ? bool = fields['Width (inches)'] == filters.width : bool = false
        }
        if (!!filters?.length && bool) {
            !!fields['Length (inches)'] ? bool = fields['Length (inches)'] == filters.length : bool = false
        }
        if (!!filters?.diameter && bool) {
            !!fields['Diameter (inches)'] ? bool = fields['Diameter (inches)'] == filters.diameter : bool = false
        }
        return bool
    }

    const create = () => {
        let obj = setLedsForAll(area, luminaire);
        const updatedArea = updateProductType(area, obj, 'control', control, fromAll, luminaireId);

        setArea(updatedArea);
    }


    useEffect(() => {
        if (createKey === true) {
            create()
            setCreateKey(false)
            onClose()
        }
    },[createKey])

    const handleSelect = (item) => {
        setSelectedItems(prevSelectedItems => {
            if (prevSelectedItems.includes(item)) {
                return prevSelectedItems.filter(i => i !== item);
            } else {
                return [...prevSelectedItems, item];
            }
        });
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedItems([]);
        } else {
            setSelectedItems(fetchedDataControl?.filter((item) => validate(item) === true).map(item => item.id));
        }
        setSelectAll(!selectAll);
    };

    useEffect(() => {
        if (!data) return
        setFetchedDataControl(data.data.data)
        setSelectedItems(control.hasOwnProperty('controlRecomendedCustomPriceIdes') ? control.controlRecomendedCustomPriceIdes : [])
        setControlAirtable(control.hasOwnProperty('controlRecomendedAirtableArray') ? control.controlRecomendedAirtableArray : [])
        if (dataCustomBids){
            setCustomBids(dataCustomBids.data.data)
        }
        setControl({
            ...control,
            controlRecomendedQty: luminaire?.controlRecomendedQty ? luminaire?.controlRecomendedQty :
                luminaire?.controlQTYFixture ? luminaire?.controlQTYFixture : ''
        })
        data.data.data.forEach(item1 => {
            item1.fields['Bid Status'] = 'review'
            if (dataCustomBids){
                dataCustomBids.data.data.forEach(item2 => {
                    if (item1.id === item2.fields['Product ID']) {
                        if (item2.fields['SU PPU ($)']){
                            item1.fields['SU PPU ($) Custom'] = item2.fields['SU PPU ($)'];
                            item1.fields['SU PPU ($) Custom FE'] = item2.fields['FE PPU ($)'];
                            item1.fields['Bid Status'] = 'accepted'
                        } else {
                            item1.fields['Bid Status'] = 'pending'
                        }
                    }
                });
            }
        });
    }, [data, dataCustomBids])


    useEffect(() => {
        if (selectedItems.length > 0) {
            if (customPricing.control) {
                setControl({
                    ...control,
                    controlRecomendedCustomPriceIdes: selectedItems,
                    controlRecomendedAirtable: controlAirtable?.length > 0 && JSON.stringify(controlAirtable[0].fields),
                })
            } else {
                setControl({
                    ...control,
                    controlRecomendedCustomPriceIdes: [],
                })
            }
        } else {
            setControl({
                ...control,
                controlRecomendedCustomPriceIdes: [],
            })
        }
    }, [selectedItems])

    useEffect(() => {
        if (controlAirtable.length > 0) {
            setControl({
                ...control,
                controlRecomendedAirtable: JSON.stringify(controlAirtable[0].fields),
                controlRecomendedAirtableArray: controlAirtable,
                controlRecomendedDescription: controlAirtable[0].fields['Control'] || controlAirtable[0].fields['FE Product Description']
            })
        } else {
            setControl({
                ...control,
                controlRecomendedAirtable: [],
                controlRecomendedAirtableArray: [],
                controlRecomendedDescription: '',
            })
        }
    }, [controlAirtable])

    useEffect(() => {
        if (type === 'control') {
            refetch()
        }
    }, [type])

    const filteredControls = (fetchedDataControl?.filter((item) => validate(item) === true) ?? [])
        .sort((a, b) => Number(expandedSearch.includes(b.fields['Type']))
            - Number(expandedSearch.includes(a.fields['Type'])))
    const expandedSearchOptions = CONTROL_TYPE
    const expandedSearchKey = JSON.stringify(expandedSearch)
    const expandedResultsKey = JSON.stringify(filteredControls
        .filter(item => expandedSearch.includes(item.fields['Type']))
        .map(item => item.id))

    useLayoutEffect(() => {
        if (isOpen && resultsListRef.current) {
            resultsListRef.current.scrollTop = 0
        }
    }, [isOpen, expandedSearchKey, expandedResultsKey])

    if (isLoading) return <Loading height='100%'/>

    return (
        <Stack spacing="5">
            <NavigateModal
                label={description}
                leftAction={() => {
                    create()
                    setType('power')
                }}
                rightAction={() => {
                    create()
                    setType('accessory')
                }}
                left="Power Supply"
                right="Accessories"/>
            <HStack w="full" justifyContent="center" position="relative" alignItems="center" py={5}>
                <Box position="absolute" bg="#A9A9A9" w="full" h="1px"/>
                <Box px="2" position="relative" bg="white" textTransform="uppercase" fontWeight="400" fontSize="xl"
                     color="#2C628D" as="span">
                    control details
                </Box>
            </HStack>
            <HStack spacing="5" alignItems="flex-end">
                <InputLabel
                    height='46px'
                    disabled={fromAll || isFetching || isFetchingBids}
                    maxW="80px" type="number"
                    value={control?.controlRecomendedQty}
                    onChange={(e) => setControl({...control, controlRecomendedQty: e.target.value})}
                    pattern="[0-9]*" label="QTY"/>
                <Box position='relative' width='100%' height='46px' css={styles.styledList}>
                    <Flex
                        alignItems='center'
                        onClick={() => {
                            refetch()
                            setIsOpen(!isOpen)
                        }}
                        bg='#EEEEEE'
                        cursor='pointer'
                        border='1px solid #ccc'
                        borderBottom='none'
                        borderBottomLeftRadius='6px'
                        position='relative'
                        borderBottomRightRadius='6px'
                        fontSize='18px'
                        p='10px 30px'
                    >
                        {controlAirtable?.length > 0
                            ? controlAirtable.map(item => item.fields["Control"] || item.fields["FE Product Description"]).join(', ')
                            : "No Change"}

                        <ArrowDownIcon
                            style={{
                                position: 'absolute',
                                right: '10px',
                                top: '18px'
                            }}
                        />
                    </Flex>
                    {isOpen && (
                        <ul
                            ref={resultsListRef}
                            style={{
                                position: 'absolute',
                                top: '99%',
                                left: 0,
                                right: 0,
                                border: '1px solid #ccc',
                                margin: 0,
                                padding: 0,
                                listStyle: 'none',
                                backgroundColor: 'white',
                                zIndex: 1000,
                                maxHeight: '500px',
                                overflowY: 'auto'
                            }}
                        >
                            {(isLoading || isFetching) && filteredControls.length === 0 ? (
                                <li
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        padding: '20px'
                                    }}
                                >
                                    <Loading height='50px' />
                                </li>
                            ) : (
                                <>
                                    <li
                                        style={{
                                            cursor: 'pointer',
                                            padding: '8px 8px 0 30px'
                                        }}
                                        onClick={() => {
                                            setControlAirtable([]);
                                            setSelectedItems([]);
                                            if (!customPricing.control) setIsOpen(false);
                                        }}
                                    >
                                        Select
                                    </li>

                                    {customPricing.control && (
                                        <li
                                            style={{
                                                padding: '8px 8px 0 8px',
                                                cursor: 'pointer',
                                                position: 'relative',
                                                display: 'flex',
                                                alignItems: 'center'
                                            }}
                                        >
                                            <Checkbox
                                                size='lg'
                                                iconColor='black'
                                                isChecked={selectAll}
                                                mr='8px'
                                                borderColor='#222222'
                                                onChange={handleSelectAll}
                                                _checked={{
                                                    "& .chakra-checkbox__control": {
                                                        background: "#FFE68D",
                                                        boxShadow: 'none',
                                                        borderColor: 'black',
                                                        outline: 'none'
                                                    }
                                                }}
                                                _hover={{
                                                    "& .chakra-checkbox__control": {
                                                        background: "#FFE68D",
                                                        boxShadow: 'none',
                                                        borderColor: 'black',
                                                        outline: 'none'
                                                    }
                                                }}
                                                _focus={{
                                                    "& .chakra-checkbox__control": {
                                                        background: "#FFE68D",
                                                        borderColor: 'black',
                                                        boxShadow: 'none'
                                                    }
                                                }}
                                                _focusVisible={{
                                                    "& .chakra-checkbox__control": {
                                                        outline: 'none',
                                                        boxShadow: 'none'
                                                    }
                                                }}
                                            >
                                                <Heading m={0} fontSize='14px'>
                                                    Select All
                                                </Heading>
                                            </Checkbox>
                                        </li>
                                    )}
                                    {filteredControls.length === 0 && (
                                        <li
                                            style={{
                                                color: '#666666',
                                                cursor: 'default',
                                                padding: '16px 30px'
                                            }}>
                                        </li>
                                    )}
                                    {filteredControls
                                        .map(item => (
                                            <li
                                                key={item.id}
                                                className='list-item'
                                                style={{
                                                    backgroundColor: controlAirtable?.length > 0 && item.id === controlAirtable[0].id
                                                        ? '#A9A9A9'
                                                        : expandedSearch.includes(item.fields['Type'])
                                                            ? expandedSearchColors[item.fields['Type']]
                                                            : 'transparent',
                                                    color: controlAirtable?.length > 0 && item.id === controlAirtable[0].id
                                                        ? '#222222'
                                                        : expandedSearch.includes(item.fields['Type'])
                                                            ? expandedSearchTextColors[item.fields['Type']]
                                                            : 'inherit',
                                                    padding: customPricing.control
                                                        ? '8px 8px 0 8px'
                                                        : '8px 30px 0 30px',
                                                    cursor: 'pointer',
                                                    position: 'relative',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}
                                                onClick={() => {
                                                    if (!customPricing.control) {
                                                        setControlAirtable(prev =>
                                                            prev.some(control => control.id === item.id)
                                                                ? prev.filter(control => control.id !== item.id)
                                                                : [item]
                                                        );
                                                        setIsOpen(false);
                                                    }
                                                }}
                                            >
                                                {customPricing.control ? (
                                                    <>
                                                        {item.fields['Bid Status'] === 'pending' ||
                                                        item.fields['Bid Status'] === 'accepted' ? (
                                                            <Flex
                                                                mr='8px'
                                                                border='2px solid black'
                                                                alignItems='center'
                                                                justifyContent='center'
                                                                borderRadius='2px'
                                                                bg={
                                                                    item.fields['Bid Status'] === 'pending'
                                                                        ? '#FFE68D'
                                                                        : '#8FCF74'
                                                                }
                                                                width='20px'
                                                                height='20px'
                                                            >
                                                                {item.fields['Bid Status'] === 'pending' ? (
                                                                    <PendingIcon />
                                                                ) : (
                                                                    <DollarIcon />
                                                                )}
                                                            </Flex>
                                                        ) : (
                                                            <Checkbox
                                                                size='lg'
                                                                iconColor='black'
                                                                borderColor='#222222'
                                                                isChecked={selectedItems.includes(item.id)}
                                                                onChange={() => handleSelect(item.id)}
                                                                mr='8px'
                                                                _checked={{
                                                                    "& .chakra-checkbox__control": {
                                                                        background: "#FFE68D",
                                                                        boxShadow: 'none',
                                                                        borderColor: 'black'
                                                                    }
                                                                }}
                                                            />
                                                        )}

                                                        <Text
                                                            as='span'
                                                            fontSize='18px'
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setControlAirtable(prev =>
                                                                    prev.some(
                                                                        control => control.id === item.id
                                                                    )
                                                                        ? prev.filter(
                                                                            control =>
                                                                                control.id !== item.id
                                                                        )
                                                                        : [item]
                                                                );
                                                            }}
                                                        >
                                                            {item.fields["Control"]}
                                                        </Text>

                                                        &nbsp;

                                                        <Text
                                                            as='span'
                                                            fontSize='18px'
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setControlAirtable([item]);
                                                            }}
                                                        >
                                                            {item.fields["SU PPU ($) Custom"]
                                                                ? `$${item.fields["SU PPU ($) Custom"]}`
                                                                : ''}
                                                        </Text>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Text
                                                            as='span'
                                                            fontSize='18px'
                                                        >
                                                            {item.fields["FE Product Description"]}
                                                        </Text>

                                                        &nbsp;

                                                        <Text as='span' fontSize='18px'>
                                                            {item.fields["SU PPU ($) Custom"]
                                                                ? `$${item.fields["SU PPU ($) Custom"]}`
                                                                : ` $${Number(
                                                                    item.fields["FE PPU ($)"]
                                                                ).toFixed(2)}`}
                                                        </Text>
                                                    </>
                                                )}

                                                <Flex
                                                    display={
                                                        customPricing.control &&
                                                        (
                                                            !item.fields["Price Per Unit ($)"] ||
                                                            item.fields["Price Per Unit ($)"] === '$0.00'
                                                        )
                                                            ? 'flex'
                                                            : 'none'
                                                    }
                                                    alignItems='center'
                                                    justifyContent='center'
                                                    borderRadius='2px'
                                                    bg={
                                                        item.fields['Bid Status'] === 'pending'
                                                            ? '#FFE68D'
                                                            : item.fields['Bid Status'] === 'accepted'
                                                                ? '#8FCF74'
                                                                : '#FF7F56'
                                                    }
                                                    width='20px'
                                                    height='20px'
                                                    position='absolute'
                                                    right='30px'
                                                    top='8px'
                                                >
                                                    {item.fields['Bid Status'] === 'pending' ? (
                                                        <PendingIcon />
                                                    ) : item.fields['Bid Status'] === 'accepted' ? (
                                                        <DollarIcon />
                                                    ) : (
                                                        '?'
                                                    )}
                                                </Flex>
                                            </li>
                                        ))}
                                </>
                            )}
                        </ul>
                    )}
                </Box>
            </HStack>
            <HStack w="full" justifyContent="center" position="relative" alignItems="center" py={5}>
                <Box position="absolute" bg="#A9A9A9" w="full" h="1px"/>
                <Box px="2" position="relative" bg="white" textTransform="uppercase" fontWeight="400" fontSize="xl"
                     color="#2C628D" as="span">
                    filters
                </Box>
            </HStack>
            <HStack spacing="5">
                <ChakraSelectLabel
                    height='46px'
                    label="Type:"
                    placeholder="Select"
                    value={control?.controlRecomendedType}
                    onChange={(e) => {
                        setFilters({...filters, type: e.target.value})
                        setControl({...control, controlRecomendedType: e.target.value})
                    }}>
                    <option value="Wall Switch">Wall Switch</option>
                    <option value="Timer">Timer</option>
                    <option value="Occupancy Sensor">Occupancy Sensor</option>
                    <option value="Daylight Sensor">Daylight Sensor</option>
                </ChakraSelectLabel>
                <ChakraSelectLabel
                    height='46px'
                    label="Manufacturer:"
                    placeholder="Select"
                    value={control?.controlRecomendedManufacturer}
                    onChange={(e) => {
                        setFilters({...filters, manufacturer: e.target.value})
                        setControl({...control, controlRecomendedManufacturer: e.target.value})
                    }}>
                </ChakraSelectLabel>
                <ChakraSelectLabel
                    height='46px'
                    label="Model:"
                    placeholder="Select"
                    value={control?.controlRecomendedModel}
                    onChange={(e) => {
                        setFilters({...filters, model: e.target.value})
                        setControl({...control, controlRecomendedModel: e.target.value})
                    }}>
                </ChakraSelectLabel>
                <InputLabel
                    height='46px'
                    value={control?.controlRecomendedProductCode}
                    onChange={(e) => {
                        setFilters({...filters, productCode: e.target.value})
                        setControl({...control, controlRecomendedProductCode: e.target.value})
                    }}
                    label="Product Code:"/>
            </HStack>
            <HStack spacing="5">
                <InputLabel
                    height='46px' type="number" pattern="[0-9]*" value={filters?.length}
                    onChange={(e) => {
                        setFilters({...filters, length: e.target.value})
                    }}
                    label="Dimensions-Length (in):"/>
                <InputLabel
                    height='46px' type="number" pattern="[0-9]*" value={filters?.width}
                    onChange={(e) => {
                        setFilters({...filters, width: e.target.value})
                    }}
                    label="Dimensions-Width (in):"/>
                <InputLabel
                    height='46px' type="number" value={filters?.depth} label="Dimensions-Depth (in):"
                    onChange={(e) => {
                        setFilters({...filters, depth: e.target.value})
                    }}/>
                <InputLabel
                    height='46px' type="number" value={filters?.diameter}
                    onChange={(e) => {
                        setFilters({...filters, diameter: e.target.value})
                    }}
                    label="Dimensions-Diameter (in):"/>
            </HStack>
            <HStack spacing='5' justifyContent='space-between'>
                <HStack spacing='60px'>
                    <Heading fontWeight='400' m={0} color='#2C628D' fontSize='14px'>
                        Show Custom <br/>Price Options
                    </Heading>
                    <Checkbox
                        _checked={{
                            "& .chakra-checkbox__control": {background: "#D4E6FF", boxShadow: 'none'}
                        }}
                        _hover={{
                            "& .chakra-checkbox__control": {background: "#D4E6FF", boxShadow: 'none'}
                        }}
                        iconColor='black'
                        onChange={(e) => {
                            refetch()
                            if (!e.target.isChecked) {
                                setSelectedItems([])
                                setControlAirtable([])
                            }
                            setCustomPricing({...customPricing, control: !customPricing.control})
                        }}
                        isChecked={customPricing.control} color='#A9A9A9' width='20px' height='20px'
                        borderColor='#2C628D'>
                        Yes
                    </Checkbox>
                </HStack>
                <HStack spacing='40px' width='40%'>
                    <Heading fontWeight='400' m={0} color='#2C628D' fontSize='14px'>
                        Buy American
                    </Heading>
                    <Checkbox
                        _checked={{
                            "& .chakra-checkbox__control": {background: "#D4E6FF", boxShadow: 'none'}
                        }}
                        _hover={{
                            "& .chakra-checkbox__control": {background: "#D4E6FF", boxShadow: 'none'}
                        }}
                        onChange={() => {
                            setBuyAmerican(!buyAmerican)
                        }}
                        isChecked={buyAmerican}
                        iconColor='black'
                        color='#A9A9A9' width='20px' height='20px' borderColor='#2C628D'>
                        Yes
                    </Checkbox>
                </HStack>
            </HStack>
            <HStack spacing='73px' justifyContent='space-between'>
                <Heading fontWeight='400' m={0} color='#2C628D' fontSize='14px'>
                    Expanded Search
                </Heading>
                <CustomSelectMultiple
                    width='748px'
                    value={expandedSearch}
                    setValue={setExpandedSearch}
                    options={expandedSearchOptions}
                    optionColors={expandedSearchColors}
                    optionIconColors={expandedSearchTextColors}
                />
            </HStack>
        </Stack>
    )
}

export default Control
